import produce from "immer";

// The initial state of the App
export const initialState = {};

const appReducer = (state = initialState, action) =>
  produce(state, draft => {});

export default appReducer;
